import { withStyles } from "@material-ui/core/styles";
import Monto from "./Monto";
import styles from "./styles";

export default withStyles(styles)(Monto);
